import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { memory } from '../pkg/index_bg.wasm';
import { FontManager } from './utils/fontManager';
import { imageStorage } from './service/image_storage';

import './index.scss';
import Application from './components/Application';
import Footer from './components/Footer';

declare global {
  interface Window {
    requestImageTexture: (id: string) => Promise<void>;
  }
}

import('../pkg')
  .then(({ App }) => {
    const app = App.new();

    // Mount global texture loader for Rust
    window.requestImageTexture = async (id: string) => {
      console.log(`[JS] Requesting texture for ${id}`);
      try {
        const record = await imageStorage.getImage(id);
        if (record) {
          const bitmap = await createImageBitmap(record.blob);
          app.update_image_texture(id, bitmap);
        } else {
          console.warn(`[JS] Image ${id} not found in storage.`);
        }
      } catch (e) {
        console.error(`[JS] Failed to load texture ${id}:`, e);
      }
    };

    const fontManager = new FontManager(app, memory);

    // 立即渲染应用（不等待字体）
    app.load_saved_data();
    ReactDOM.render(
      <Application app={app} fontManager={fontManager} />,
      document.getElementById('application')
    );

    // 异步初始化字体（加载 eager 字体）
    fontManager.initialize().catch(e => {
      console.error('Failed to initialize fonts:', e);
    });
  })
  .catch(console.error);

const el = document.createElement('div');
document.body.appendChild(el);
ReactDOM.render(<Footer />, el);

